const newsletterForm = {
  displayField: null,
  name: 'Newsletter Form',
  description: 'A beige block containing a newsletter signup form',
  fields: [
    {
      id: 'header',
      name: 'Header for form',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'eyebrow',
      name: 'Message under header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header2',
      name: 'Form submitted message Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'eyebrow2',
      name: 'Form Submitted message text',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'newsletterForm',
    version: 3,
    updatedAt: '2023-05-01T02:52:25.725Z'
  }
};
export default newsletterForm;